export const CAN_EDIT_FORMS = 'CAN_EDIT_FORMS'